import ServiceTemplate from './service-page-template/service-page-template.jsx';
import { imagesMetadata } from '../../imagesMetadata.js';

const heroImageSrc = '/static/images/installations/burwood-bathroom-mirror-installation-01.webp';
const heroMeta = imagesMetadata[heroImageSrc];

const excludedImages = [
  heroImageSrc,
  // Add any other image paths to exclude here...
];

const installationGalleryImages = Object.entries(imagesMetadata)
  .filter(([src]) => src.startsWith('/static/images/installations/') && !excludedImages.includes(src))
  .map(([src, meta], index) => ({
    id: index + 1,
    src,
    alt: meta.alt,
    location: meta.location
  }));

export default function Installation() {
    const servicesData = {
        title: "Installation Services",
        subtitle: "Professional TV mounting, blinds, curtains, shelves, mirrors and bathroom fittings installed safely and neatly.",
        metaTitle: "Handyman Installation Services Melbourne | TV, Shelves & Blinds",
        metaDesc: "Melbourne installation services for shelves, mirrors, curtains, blinds and bathroom fittings. Get fixtures installed securely by an experienced handyman.",
        canonicalPath: "/installations",

        solutionsTitle: "Our Professional Installation Services",
        solutionsIntro: "We provide precise, secure, and visually clean installations for a wide range of fixtures and fittings.",

        solutionsList: [
            { 
                emoji: "📺", 
                heading: "TV Wall Mounting & Cable Management", 
                text: "Secure mounting on any wall type with neat cable hiding for a modern, professional look." 
            },
            { 
                emoji: "🪟", 
                heading: "Curtains, Blinds & Tracks", 
                text: "Installation of curtains, roller blinds, venetians, and curtain tracks with precise alignment." 
            },
            { 
                emoji: "🚿", 
                heading: "Bathroom & Kitchen Accessories", 
                text: "Towel rails, mirrors, shelves, grab bars, toilet roll holders and other fixtures." 
            },
            { 
                emoji: "🪞", 
                heading: "Shelves, Hooks & Mirrors", 
                text: "Floating shelves, picture hooks, heavy mirrors, and decorative installations." 
            }
        ],

        serviceImage: {
            src: heroImageSrc,
            alt: heroMeta?.alt || 'Professional arched bathroom mirror installation over a vanity in Burwood clean hole drilled into tiles by Handyman In melbourne'
        },

        extendedDetails: [
            {
                title: "Correct Fixings for Every Surface",
                body: "We assess each wall type (plasterboard, brick, concrete, stud) and use the appropriate anchors and brackets to ensure everything is securely and safely installed."
            },
            {
                title: "Neat & Professional Finish",
                body: "Special attention is given to alignment, levelling, and cable management so your new installations look clean, straight, and well-integrated into your home."
            },
            {
                title: "Safety & Load Considerations",
                body: "Especially important for TVs, heavy mirrors, and grab rails — we always prioritise proper weight ratings and secure fixing methods."
            },
            {
                title: "Minimal Disruption & Clean Site",
                body: "We work efficiently, protect your belongings, control dust, and leave the area spotless after every installation."
            }
        ],

        galleryImages: installationGalleryImages,

        faqs: [
            {
                question: 'What types of installations do you specialise in?',
                answer: 'We handle blinds, curtains, shelves, smart locks, doorbells, bathroom fixtures, kitchen accessories, and more.'
            },
            {
                question: 'Do you install smart home devices?',
                answer: 'Yes — video doorbells, security cameras, smart lighting, thermostats, and speakers.'
            },
            {
                question: 'Do I need to buy materials beforehand?',
                answer: 'You can supply them or we can organise suitable products for you.'
            },
            {
                question: 'Are you licensed for electrical or plumbing work?',
                answer: 'We handle minor electrical and plumbing tasks. For major work we coordinate with licensed trades.'
            },
        ]
    };

    const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": servicesData.title,
    "serviceType": servicesData.title,
    "description": servicesData.metaDesc,
    "url": `https://handymaninmelbourne.au${servicesData.canonicalPath}`,
    "provider": {
      "@type": "LocalBusiness",
      "name": "Handyman In Melbourne",
      "url": "https://handymaninmelbourne.au/"
    },
    "areaServed": [
            "City of Melbourne VIC",
            "City of Port Phillip VIC",
            "City of Glen Eira VIC",
            "City of Stonnington VIC",
            "City of Boroondara VIC",
            "City of Whitehorse VIC",
            "City of Manningham VIC",
            "City of Monash VIC",
            "City of Kingston VIC",
            "City of Yarra VIC",
            "City of Moonee Valley VIC",
            "City of Darebin VIC",
            "City of Greater Dandenong VIC"
        ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }}
      />
      <ServiceTemplate {...servicesData} />
    </>
  );
}
